import { render, staticRenderFns } from "./button-locales.vue?vue&type=template&id=21d16086&"
import script from "./button-locales.vue?vue&type=script&lang=ts&"
export * from "./button-locales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports